import React, { useState, useEffect } from "react";
import "./Accordion.scss";

const Accordion = ({
  title = "Accordion Title",
  children,
  defaultOpen = false,
  headerBg = "#f8f9fa",
  height = "auto",
  collapsible = true,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  useEffect(() => {
    setIsOpen(defaultOpen);
  }, [defaultOpen]);

  const toggleAccordion = () => {
    if (!collapsible) return;
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="custom-accordion" style={{ height }}>
      {/* Header */}
      <div
        className="custom-accordion__header d-flex align-items-center justify-content-between"
        style={{ backgroundColor: headerBg }}
        onClick={toggleAccordion}
      >
        <span className="custom-accordion__title">{title}</span>

        {collapsible && (
          <i
            className={`fa ${
              isOpen ? "fa-chevron-up" : "fa-chevron-down"
            }`}
          ></i>
        )}
      </div>

      {/* Body */}
      <div
        className={`custom-accordion__body ${
          isOpen ? "open" : "collapsed"
        }`}
      >
        <div className="custom-accordion__content">{children}</div>
      </div>
    </div>
  );
};

export default Accordion;
